<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal.emit()"
  class="flx-ds flex flex-col max-h-full"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    Edit Shades
  </div>
  <div
    class="flx-modal-subtitle gray"
    flxModalHeaderSubtitle
  >
    {{ colorName() }} Color
  </div>
  <div class="flex flex-col gap-2 w-full">
    @for (shade of displayShades() | keyvalue; track shade.key) {
      <flx-input [hasClear]="true">
        <flx-label>{{ shade.key }}</flx-label>
        <input
          [formField]="shadesForm[shade.key]"
          flxHexColorMask
          flxInput
          placeholder="#"
          type="text"
        />
        <div
          [style.backgroundColor]="shadesForm[shade.key]().controlValue()"
          class="w-4 h-4 rounded-sm border-gray-300 border"
          flxPrefix
        ></div>
      </flx-input>
    }

    <div
      class="w-full flex flex-row justify-center items-center gap-4 mt-4 sticky bottom-0 bg-white"
    >
      <button
        (click)="closeModal.emit()"
        class="w-full rounded font-semibold"
        flxButton
        variant="ghost"
      >
        Discard
      </button>
      <button
        (click)="save()"
        class="w-full text-white border-transparent rounded bg-blue-500 font-semibold disabled:opacity-35"
        flxButton
        type="button"
      >
        Save
      </button>
    </div>
  </div>
</flx-modal>
